/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Team_Share_Selected_CountInputs */



/**
* | output |
* | --- |
* | "{count} selected" |
*
* @param {Team_Share_Selected_CountInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_share_selected_count = /** @type {((inputs: Team_Share_Selected_CountInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Share_Selected_CountInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.count} selected`)
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} selected`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.count} selected`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`${i?.count} selected`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.count} selected`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`${i?.count} selected`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.count} selected`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.count} selected`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`${i?.count} selected`)
	return /** @type {LocalizedString} */ (`${i?.count} selected`)
});